import * as React from "react";
import {
    Avatar,
    Box, Card, Container, IconButton, Typography,
} from "@mui/material";
import ButtonComponent from "components/Button";
import TextFieldComponent from "components/TextField";
import {
    getButtonDataSendMsg,
    getTextfieldDataMessage,
    schema,
} from "./helper";
import {
    checkUserAllowed,
    getLocalDate, getPriceCurrency,
    parseTextWithLinks
} from "helpers/utils";
import {H2, H4, H5, H6} from "components/CustomTypography";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import {DATE_FORMAT_SHORT, DATE_TIME_FORMAT_SHORT} from "config/constants";
import CustomSectionCreator from "components/CustomSectionCreator";
import {useState} from "react";
import ShopHeaderBack from "components/elements/main/ShopHeaderBack";
import AdminSellerShopDetail from "components/elements/admin/shops/AdminSellerShopDetail";


const AdminSellerSubscriptionEditor = (props) => {

    const {
        setState, selectedShop, symbol,
            approvedrejectShopClicked, disableShopClicked, enableShopClicked, updateDomainClicked, updateSocialClicked,
            verifiedShopClicked, unlockURLShopClicked,
            displayReqClicked, displayDeliveredClicked, displayPrintedClicked, handleSalesLeadClicked,
            handleShopInternalMessageClicked, handleOrderMessageClicked,
            handleSalesLeadSelected, salesLeadOptions, shopMatchingList,
            onCancel, orderdetail, isLoading, userDetails, currency
    } = props;

  const {
     created_at: createdAt, order_id: orderIdValue, status, pin, message, internalmessage, subdomain,
      instahandle, facebookhandle, whatsapphandle
  } = selectedShop || {};

    const { _id, order_id, plans, order_type, paymentstatus, payment_id, paymentmethod, messages,
        total_price, total_discount, total_service, total_tax, total_order } = orderdetail || {};


    const [shopModeState, setShopModeState] = useState("PREVIEW");

  const [blur, setblur] = React.useState({
    status: false,
  });

  const onFinishApproved = () => {
      approvedrejectShopClicked({ shop_id: orderIdValue, status: "approve" });
  };

    const onFinishRejected = () => {
        approvedrejectShopClicked({ shop_id: orderIdValue, status: "reject" });
    };

    const onFinishDeleted = () => {
        approvedrejectShopClicked({ shop_id: orderIdValue, status: "delete" });
    };

    const onFinishUpdateDomain = () => {
        updateDomainClicked({ shop_id: orderIdValue, subdomain: subdomain });
    };

    const onFinishUpdateSocial = () => {
        updateSocialClicked({ shop_id: orderIdValue, instahandle: instahandle, facebookhandle:  facebookhandle, whatsapphandle:  whatsapphandle });
    };

    const onFinishSendInternalMsg = () => {
        handleShopInternalMessageClicked( orderIdValue, message );
    };

    const onFinishSendMsg = () => {
        handleOrderMessageClicked( orderIdValue, message );
    };

    const onFinishUnlocked = () => {
        unlockURLShopClicked({ shop_id: orderIdValue });
    };

    const onFinishEnable = () => {
        enableShopClicked({ shop_id: orderIdValue });
    };

    const onFinishDisable = () => {
        disableShopClicked({ shop_id: orderIdValue });
    };

    const onFinishVerified = () => {
        verifiedShopClicked(orderIdValue, pin);
    };

    const onFinishDisplayReq = () => {
        displayReqClicked({ shop_id: orderIdValue });
    };

    const onFinishDisplayDelivered = (formData) => {
        displayDeliveredClicked(orderIdValue, formData);
    };

    const onFinishDisplayPrinted = () => {
        displayPrintedClicked({ shop_id: orderIdValue });
    };

    const onFinishSalesLead = (event) => {
        handleSalesLeadClicked(orderIdValue, event.target.value);
    };

    const onSelectingSalesLead = (event) => {
        handleSalesLeadSelected(event.target.value);
    };

    const hasError = () => {
    try {
      return !schema.validateSync(selectedShop);
    } catch (err) {
      return true;
    }
  };

  const handleBlur = (field) => {
    setblur({ ...blur, [field]: true });
  };

  const isTouched = () => (blur.status);

  const getError = (field) => {
    if (blur[field] && hasError()) {
      try {
        schema.validateSyncAt(field, selectedShop);
      } catch (err) {
        return err.message;
      }
    }
    return null;
  };

    const handleTextFieldChange = (event, field) => {
        setState(event.target.value, field);
    };

    const handleShopButtonClick = () => {
        setShopModeState("SHOP_DETAIL");
    };

    const renderOrderInformation = () => (
        <>
            <Box mt={2}  mb={2}>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Order No:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {orderdetail.order_id}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Status:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {orderdetail.status}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Added On:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {getLocalDate(orderdetail.created_at, DATE_TIME_FORMAT_SHORT)}
                        </H5>
                    </Box>
                </Box>
                <Box width="100%" display="flex">
                    <Box width="30%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            Payment:
                        </H5>
                    </Box>
                    <Box width="70%" >
                        <H5 fontSize={14} textAlign="left" ellipsis>
                            {getLocalDate(orderdetail.order_date, DATE_TIME_FORMAT_SHORT)}
                        </H5>
                    </Box>
                </Box>
            </Box>
            <Box width="100%" display="flex">
                <Box width="30%" >
                    <H5 fontSize={14} textAlign="left" ellipsis>
                        Shop:
                    </H5>
                </Box>
                <Box width="70%" >
                    <H5 fontSize={14} textAlign="left" ellipsis>
                        {orderdetail.shop && orderdetail.shop.title}
                    </H5>
                </Box>
            </Box>
            <Box width="100%" mb={2} alignItems="center" display="flex">
                <Box width="30%" >
                    <H5 fontSize={14} textAlign="left" ellipsis>View Shop</H5>
                </Box>
                <Box width="70%">
                    <ButtonComponent
                        type="primary"
                        variant="outlined"
                        name="View Shop"
                        size="small"
                        onClick={handleShopButtonClick}
                    />
                </Box>
            </Box>
            <hr className="solid" />
        </>
    );

    const renderOrderItems = () => (
        <Box>
            {plans && plans.map((item, index) => (
                <Box className="styled-card" width="100%" display="flex" p={1}>
                    <Box width="80%" order={1} ml={2}>
                        <H2 fontSize={14} textAlign="left" ellipsis> {item.plan.title}</H2>
                        <H5 fontSize={14} textAlign="left" ellipsis> {item.plan.description}</H5>
                    </Box>
                    <Box width="20%" order={2} ml={2}>
                            {getPriceCurrency(item.price, currency)}
                    </Box>
                </Box>
            ))}
        </Box>
    );


    const renderOrderTotal = () => (
        <Box>
            <Box className="styled-card" width="100%" display="flex" p={1}>
                <Box width="80%" order={1} ml={2}>
                    Subtotal:
                </Box>
                <Box width="20%" order={2} ml={2}>
                    {getPriceCurrency(total_price, currency)}
                </Box>
            </Box>


            <Box className="styled-card" width="100%" display="flex" p={1}>
                <Box width="80%" order={1} ml={2}>
                   Discount:
                </Box>
                <Box width="20%" order={2} ml={2}>
                    {getPriceCurrency(total_discount, currency)}
                </Box>
            </Box>

            <Box className="styled-card" width="100%" display="flex" p={1}>
                <Box width="80%" order={1} ml={2}>
                    Service Charge:
                </Box>
                <Box width="20%" order={2} ml={2}>
                    {getPriceCurrency(total_service, currency)}
                </Box>
            </Box>

            <Box className="styled-card" width="100%" display="flex" p={1}>
                <Box width="80%" order={1} ml={2}>
                    Taxes:
                </Box>
                <Box width="20%" order={2} ml={2}>
                    {getPriceCurrency(total_tax, currency)}
                </Box>
            </Box>

            <hr className="solid" />

            <Box className="styled-card" width="100%" display="flex" p={1}>
                <Box width="80%" order={1} ml={2}>
                    Total:
                </Box>
                <Box width="20%" order={2} ml={2}>
                    {getPriceCurrency(total_order, currency)}
                </Box>
            </Box>
        </Box>
    );


    const renderShopSendMessages = () => (
        <Box>
            <CustomSectionCreator isSubtle={true} title="Message to Shop owner:"  />
            <Box mb={2}>
                {
                    getTextfieldDataMessage(message).map((element) => (
                        <Box className="textfield" m={2}>
                            <TextFieldComponent
                                required
                                label={element.label}
                                value={element.value}
                                error={!!getError(element.onChangeField)}
                                helperText={getError(element.onChangeField)}
                                onChange={(event) => handleTextFieldChange(event, element.onChangeField)}
                            />
                        </Box>
                    ))
                },
                {getButtonDataSendMsg(onFinishSendMsg).map((element) => (
                    <ButtonComponent
                        type={element.type}
                        variant={element.variant}
                        onClick={element.onClick}
                        disabled={element.disabled}
                        name={element.name}
                        size="small"
                    />
                ))
                }
            </Box>
        </Box>
            );

    const renderShopSentMessages = () => (
        <Box>
            <Box mb={2} width="100%">
                {messages && messages.map((messageItem, index) => (
                    <Box width="100%" display="flex">
                        <Box width="30%">
                            <H5 fontSize={14} textAlign="left" ellipsis>
                                {getLocalDate(messageItem.added_at, DATE_FORMAT_SHORT)} ({messageItem.added_by && messageItem.added_by.name})
                            </H5>
                        </Box>
                        <Box width="70%">
                            <H5 fontSize={14} textAlign="left" ellipsis>
                                {parseTextWithLinks(messageItem.message)}
                            </H5>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );


    const renderSearchModule = () => (
        <Container>
            <Container maxWidth="md">
                {isLoading && <Box m={10}><MockGeneralHeader  /></Box>}
                {!isLoading && renderOrderInformation()}
                {!isLoading && renderOrderItems()}
                {!isLoading && renderOrderTotal()}

                <Box mb={2}>
                    {(checkUserAllowed(userDetails.userlevel, "subscriptionsmessage")) && renderShopSendMessages()}
                    {(checkUserAllowed(userDetails.userlevel, "subscriptionsmessage")) && renderShopSentMessages()}
                </Box>
            </Container>
        </Container>
    );

    const renderCategoryEdit = () => {
        switch (shopModeState) {

            case "SHOP_DETAIL":
                return (
                    <>
                        <CustomSectionCreator isSubtle={true} title="Shop Information" />
                        <ShopHeaderBack  {...props} onCancel={() => setShopModeState("PREVIEW")} />
                        {orderdetail.shop && <AdminSellerShopDetail {...props} shopId={orderdetail.shop._id}/>}
                    </>
                );
        }
    }

    return (
        <Container>
            {shopModeState === "PREVIEW" ? (
                <>
                    <CustomSectionCreator isSubtle={true} title="Promotion Package Order" />
                    <ShopHeaderBack  {...props} onCancel={onCancel} />
                    {renderSearchModule()}
                </>
            ) : (
                renderCategoryEdit(shopModeState)
            )}
        </Container>
    );
};

export default AdminSellerSubscriptionEditor;
